import * as React from "react";
const SvgEject = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 17h14v2H5v-2zm7-12L5.33 15h13.34L12 5z",
  fill: "currentColor"
}));
export default SvgEject;